import { useEffect } from 'react'
import { toast } from 'react-toastify'

const useDismissAllToasts = () => {
  useEffect(() => {
    return toast.dismiss
  }, [])
}

export default useDismissAllToasts
